import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import "./VideoCard.css";
import { useNavigate} from "react-router-dom";

const VideoCard = (props) => {
  const navigate = useNavigate();

  const handleClick = (event) => {
    const id = event.currentTarget.id;
    navigate(`/video/${id}`, { state: { videoId: id  } });
  };


  return (
    <div className="videoCard-container">
      <button id={props.id} onClick={handleClick} className="card-button">
      {/* <Link className='link' to={`/video/${id}`}> */}
        <Card className="video-card">
          <CardMedia
            component="img"
            height="150"
            image={props.imgLink}
            alt="Video"
            className="card-img"
          />
          <CardContent className="card-content">
            <Typography gutterBottom variant="h5" className="card-text">
              {props.title}
            </Typography>
            <div>
            <Typography color="text.secondary" className="card-text">
            {props.releaseDate}
            </Typography>
            </div>
          </CardContent>
        </Card>
      </button>
  
    </div>
  );
};
export default VideoCard;
